/** Angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { CommonRole } from '../../commonrole.class';

@Injectable({
  providedIn: 'root',
})
export class BydRolesService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService.
   */
  path: string;

  /**
   * Get the common roles.
   *
   * @returns Observable<CommonRole[]>
   */
  public getCommonRoles(): Observable<CommonRole[]> {
    this.path = '/commonroles';
    return this.get();
  }

  /**
   * Get the groups roles.
   *
   * @param prjId the project id
   * @returns Observable
   */
  public getGroupsRoles(prjId: number) {
    this.path = `/projects/${prjId}/grouproles`;
    return this.get();
  }

  /**
   * Get the common role rights.
   *
   * @param roleId the role id
   * @returns Observable<number[]>
   */
  public getCommonRoleRights(roleId: number): Observable<number[]> {
    this.path = `/commonroles/${roleId}/rights`;
    return this.get();
  }

  /**
   * Add common role.
   *
   * @param roleName the role name
   * @returns Observable
   */
  public addCommonRole(roleName: string) {
    this.path = `/commonroles`;
    const body = JSON.stringify({ name: roleName });
    return this.post({ body });
  }

  /**
   * Update common role.
   *
   * @param roleId the role id
   * @param locale the locale
   * @param name the role name
   * @param description the description
   * @returns Observable
   */
  public updateCommonRole(roleId: number, locale: string, name: string, description: string) {
    this.path = `/commonroles/${roleId}/locale/${locale}`;
    const body = JSON.stringify({ name, description });
    return this.post({ body });
  }

  /**
   * Delete common role.
   *
   * @param roleId the role id
   * @returns Observable
   */
  public deleteCommonRole(roleId: number) {
    this.path = `/commonroles/${roleId}`;
    return this.delete();
  }

  /**
   * Add common role right.
   *
   * @param roleId the role id
   * @param  rightId the right id
   * @returns Observable
   */
  public addCommonRoleRight(roleId: number, rightId: number) {
    this.path = `/commonroles/${roleId}/rights/${rightId}`;
    return this.post();
  }

  /**
   * Delete common role right.
   *
   * @param roleId the role id
   * @param  rightId the right id
   * @returns Observable
   */
  public deleteCommonRoleRight(roleId: number, rightId: number) {
    this.path = `/commonroles/${roleId}/rights/${rightId}`;
    return this.delete();
  }

  /**
   * Implement inherited abstract member 'createNewInstance' from BydRhsAbstractService.
   */
  public createNewInstance() {}
}
